export const WALLET_TOP_UPS_URL = "/internal/payments/wallet-top-ups";

export const WALLET_TOP_UPS_PAGE_SIZE = 20;

/** Limits of the backend DTO; the form refuses past them instead of letting the POST answer 400. */
export const WALLET_TOP_UP_CONCEPT_MAX = 140;
export const WALLET_TOP_UP_NOTE_MAX = 1000;

/** The description coloca-nest writes on the ledger leg of a top-up — how a statement row is recognized. */
export const WALLET_TOP_UP_LEDGER_DESCRIPTION = "coloca top up";
/** Same, for a refund to the client for a payment incident (a top-up of kind `incident_refund`). */
export const WALLET_TOP_UP_REFUND_LEDGER_DESCRIPTION = "coloca refund";

/** A brand name, never translated: who credited the wallet. */
export const WALLET_TOP_UP_ORIGIN = "Coloca Payments";
